import { useEffect, useState } from 'react';
import useIsMobile from '../../../../shared/hooks/useIsMobile';
import FireRatingSelect from '../mobile-view-select';
import StructureSelectDisclaimerTable from './desktop';
import MobileViewTable from './mobile';

interface RequiredAxisTableProps {
  structureName: string;
}

const RequiredAxisTable = ({ structureName } : RequiredAxisTableProps) => {
  const isMobile = useIsMobile();
  const [selectedFireRatingIndex, setSelectedFireRatingIndex] = useState(0);

  useEffect(() => {
    setSelectedFireRatingIndex(0);
  }, [structureName]);

  return isMobile ? (
    <>
      <FireRatingSelect fireRatingIndex={selectedFireRatingIndex} setFireRatingIndex={setSelectedFireRatingIndex} />
      <MobileViewTable
        structureName={structureName}
        fireResistanceIndex={selectedFireRatingIndex}
      />
    </>
  ) : (
    <StructureSelectDisclaimerTable structureName={structureName} />
  );
};

export default RequiredAxisTable;